module.exports = __webpack_public_path__ + "static/media/screenoff.4c504ccf.gif";